import { Modal, Button } from "antd";
import { deleteDriverApi } from "api/driver";
import WarningIcon from "components/Icons/WarningIcon";
import { useDataLoadingContext } from "contexts/DataLoadingContext";
import { useNotificationContext } from "contexts/NotificationContext";
import { IDriver } from "models/driver";
import { useState } from "react";

interface IProp {
  open: boolean;
  driver: IDriver;
  handleClose: () => void;
}

export default function DeleteModal({ open, driver, handleClose }: IProp) {
  const [loading, setLoading] = useState<boolean>(false);
  const { showError, showSuccess } = useNotificationContext();
  const { loadDrivers } = useDataLoadingContext();

  const handleBan = async () => {
    setLoading(true);
    const { data, error } = await deleteDriverApi(driver.id);
    if (data) {
      showSuccess("Driver deleted successfully");
      loadDrivers();
    } else showError(error!.message);
    setLoading(false);
    handleClose();
  };

  return (
    <Modal open={open} title={null} footer={null} closeIcon={null} centered>
      <div className="w-full text-center">
        <div className="w-full text-orange-400 text-9xl flex justify-center my-6">
          <WarningIcon />
        </div>
        <h3 className="text-3xl font-semibold my-4">Are you sure?</h3>
        <p
          className="font-normal text-base"
          style={{ color: "rgba(0,0,0,.64)" }}
        >
          You're about to delete {driver.first_name} {driver.middle_name}{" "}
          {driver.last_name}
        </p>
        <div className="w-full flex mt-7 items-center justify-end gap-x-3">
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleBan} loading={loading} type="primary" danger>
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
}
